import React, { useState, useEffect, useRef } from "react";
import {
  TextField,
  Box,
  Typography,
  FormControl,
  Grid,
  Container,
  CircularProgress,
  IconButton,
  Tooltip,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useMutation, useQuery } from "@apollo/client";
import { CREATE_EVENTS, UPDATE_EVENTS } from "src/graphql/mutations";
import CustomButton from "src/components/CustomButton";
import Select from "react-select";
import { toast } from "react-toastify";
import { eventCategoryOptions, languageOptions } from "./Events";
import AddressInput from "src/components/Common/AddressInput";
import { uploadFile, uploadImage } from "src/components/Common/Utils";
import moment from "moment";
import { useFormik as useFormic } from "formik";
import backButton from "../../Images/backButton.svg";
import { EventsPageProps, validationSchema } from "./Events";
import { AddCircleOutline, RemoveCircleOutline } from "@mui/icons-material";
import { GET_EVENTS_ENUM_ALL } from "src/graphql/query";
import RichTextEditor from "src/components/Common/TextEditor";
import DisplayVideo from "src/components/video/DisplayVideo";
import { videoExtensions } from "src/constant";

const EventsPage: React.FC<EventsPageProps> = ({
  events,
  refetchEvents,
  handleClose,
}) => {
  const [formValues, setFormValues] = useState<any>({
    title: "",
    images: "",
    desktopImage: "",
    mobileImage: "",
    eventBy: "",
    description: "",
    startTime: "",
    endTime: "",
    type: "",
    price: [{ price: 0, priceTitle: "", isPriceNotConfirmed: false }],
    venue: "",
    startDate: "",
    endDate: "",
    language: "",
    artist: "",
    bookingPartner: "",
    pincode: "",
    address: {
      address_1: "",
      address_2: "",
      pinCode: "",
      location: "",
      landmark: "",
    },
    metaTitle: "",
    metaDescription: "",
    focus: "",
    contactDetails: [{ name: null, mobileNumber: null }],
    isPromoted: false,
    imageAltText: "",
  });

  const [errors, setErrors] = useState<any>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [AddEvent] = useMutation(CREATE_EVENTS);
  const [UpdateEvent] = useMutation(UPDATE_EVENTS);
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const mobileImageRef = useRef<HTMLInputElement | null>(null);
  const desktopImageRef = useRef<HTMLInputElement | null>(null);
  const formic = useFormic({
    initialValues: formValues,
    validationSchema,
    enableReinitialize: true,
    onSubmit: async () => handleSubmit,
  });
  const [desktopUrl, setDesktopUrl] = useState<string>("");
  const [galleryUrl, setGalleryUrl] = useState<string>("");
  const [useUrl, setUseUrl] = useState<boolean>(true);
  const [eventCategories, setEventCategories] = useState<any>([]);
  useEffect(() => {
    if (events) {
      setFormValues({
        title: events?.title || "",
        images: events?.images || [],
        mobileImage: events?.mobileImage || "",
        desktopImage: events?.desktopImage || "",
        eventBy: events?.eventBy || "",
        description: events?.description || "",
        startTime: events?.startTime ? moment(events?.startTime, "hh:mm A").format("HH:mm") : "",
        endTime: events?.endTime ? moment(events?.endTime, "hh:mm A").format("HH:mm") : "",
        type: events?.type || "",
        price: events?.price || [{ price: 0, priceTitle: "", isPriceNotConfirmed: false }],
        venue: events?.venue || "",
        startDate: events?.startDate
          ? moment(events.startDate).format("YYYY-MM-DD")
          : "",
        endDate: events?.endDate
          ? moment(events.endDate).format("YYYY-MM-DD")
          : "",
        language: events?.language || "",
        artist: events?.artist || "",
        address: events?.address[0] || "",
        bookingPartner: events?.bookingPartner || "",
        pincode: events?.address[0]?.pinCode || "",
        metaTitle: events?.metaTitle || "",
        metaDescription: events?.metaDescription || "",
        focus: events?.focus || "",
        contactDetails: events.contactDetails || [
          { name: null, mobileNumber: null },
        ],
        isPromoted: events?.isPromoted || false,
        imageAltText: events?.imageAltText || "",
      });
    }
  }, [events]);

  const { data, error } = useQuery(GET_EVENTS_ENUM_ALL, {
    onError: (err) => {
      toast.error("Facing issue in fetching categories");
      console.error("Query error:", err);
    },
    onCompleted: (data) => {
      const eventCategories = data?.getAllEventsEnum?.data ?? [];
      const optionObj = eventCategories?.map((item: any) => ({
        value: item?.name,
        label: item?.name,
      }));
      setEventCategories(optionObj);
    },
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formic.handleChange(e);
    // const { name, value } = e.target;
    const { name, value, type, checked } = e.target;
    // setFormValues((prev: any) => ({ ...prev, [name]: value }));
    setFormValues((prev: any) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    type: string
  ) => {
    const files = e.target.files;
    if (files && files.length > 0) {
      const file = files?.[0];
      const fileUrl = URL.createObjectURL(file);

      setFormValues((prev: any) => ({
        ...prev,
        [type]: file,
      }));
    }
  };

  const handleMultipleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files;

    // if (files && files.length > 0) {
    //   // const newFiles = Array.from(files).map((file: any) => file);
    //   const newFiles = Array.from(files);

    //   setFormValues((prev: any) => ({
    //     ...prev,
    //     images: [...prev.images, ...newFiles],
    //   }));
    // }
    if (!files || files.length === 0) return;

    let newFiles = Array.from(files);
    let existingFiles = [...(formValues.images || [])];

    let videoCount = existingFiles.filter((file: any) =>
      isVideoUrl(file)
    ).length;
    let imageCount = existingFiles.filter(
      (file: any) => !isVideoUrl(file)
    ).length;

    let newFileList = [...existingFiles];

    newFiles.forEach((file) => {
      if (isVideoUrl(file)) {
        if (file.size > 30 * 1024 * 1024) {
          alert("Video size must be less than 30MB.");
          return;
        }
        if (videoCount >= 2) {
          alert("You can only upload up to 2 videos.");
        } else {
          newFileList.push(file);
          videoCount++;
        }
      } else {
        if (imageCount >= 5) {
          alert("You can only upload up to 5 images.");
        } else {
          newFileList.push(file);
          imageCount++;
        }
      }
    });

    setFormValues((prev: any) => ({
      ...prev,
      images: newFileList,
    }));
  };

  const isVideoUrl = (url: string | File): boolean => {
    if (typeof url === "string") {
      return videoExtensions.some((ext) => url.endsWith(ext));
    } else if (url instanceof File) {
      return url.type.startsWith("video/");
    }
    return false;
  };

  const handlePincodeChange = (value: any) => {
    setFormValues((prev: any) => ({
      ...prev,
      pincode: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      setLoading(true);
      const uploadedImages: string[] = [];
      await validationSchema.validate({ ...formValues }, { abortEarly: false });
      for (const fileUrl of formValues.images) {
        if (typeof fileUrl === "string") {
          uploadedImages?.push(fileUrl);
        } else {
          if (fileUrl.type.includes("video")) {
            const response = await uploadFile(fileUrl);
            if (response?.uploadFile?.url) {
              uploadedImages?.push(response?.uploadFile.url);
            }
          } else {
            const response = await uploadImage(
              fileUrl,
              "events",
              formValues?.title
            );
            if (response?.uploadImage?.url) {
              uploadedImages?.push(response.uploadImage.url);
            }
          }
        }
      }

      if (typeof formValues?.mobileImage !== "string") {
        const response = await uploadImage(
          formValues?.mobileImage,
          "events",
          formValues?.title
        );
        if (response?.uploadImage?.url) {
          formValues.mobileImage = response?.uploadImage?.url;
        }
      }

      if (typeof formValues?.desktopImage !== "string") {
        const response = await uploadImage(
          formValues?.desktopImage,
          "events",
          formValues?.title
        );
        if (response?.uploadImage?.url) {
          formValues.desktopImage = response?.uploadImage?.url;
        }
      }

      const address = formValues?.address as any;
      if (address && address.__typename) {
        const { __typename, ...addressWithoutTypename } = address;
        formValues.address = addressWithoutTypename;
      }

      const sanitizedContactDetails = formValues.contactDetails.map(
        ({ __typename, ...rest }: any) => rest
      );
      formValues.contactDetails = sanitizedContactDetails;

      // const input = { ...formValues, images: uploadedImages };
      const input = {
        ...formValues,
        images: uploadedImages,
        startTime: moment(formValues.startTime, "HH:mm").format("hh:mm A"),
        endTime: moment(formValues.endTime, "HH:mm").format("hh:mm A"),
      };

      // await validationSchema.validate(input, { abortEarly: true });

      const response = events
        ? await UpdateEvent({
          variables: {
            _id: events._id,
            input,
          },
        })
        : await AddEvent({ variables: { input } });

      if (
        response?.data?.addEvent?.statusCode === 200 ||
        response?.data?.updateEvent?.statusCode === 200
      ) {
        toast.success(
          response.data[events ? "updateEvent" : "addEvent"].message ||
          `Event ${events ? "updated" : "created"} successfully!`
        );

        refetchEvents();
        handleClose();
      } else {
        throw new Error(
          response?.data?.addEvent?.message ||
          response?.data?.updateEvent?.message
        );
      }
    } catch (error: any) {
      if (error?.inner) {
        const validationErrors: Record<string, any> = {};
        error?.inner?.forEach((err: any) => {
          const pathParts = err?.path?.split(".");
          if (pathParts?.length > 1) {
            if (!validationErrors[pathParts[0]]) {
              validationErrors[pathParts[0]] = {};
            }
            validationErrors[pathParts[0]][pathParts[1]] = err?.message;
          } else {
            validationErrors[err?.path] = err?.message;
          }
        });
        setErrors(validationErrors);
      } else {
        toast.error(error?.message || "An error occurred. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };
  
  const handlePriceChange = (index: number, event: any) => {
    const { name, value, type, checked } = event.target;

    // const newValue = type === 'checkbox' ? checked : value;
    const newValue = type === 'checkbox' ? checked : name === 'price' ? Number(value) : value;

    let newPrices = [...formValues?.price];
    newPrices[index] = {
      ...newPrices[index],
      [name]: newValue,
    };
    setFormValues((prev: any) => ({
      ...prev,
      price: newPrices,
    }));
  };

  const handleContactChange = (index: number, event: any) => {
    const { name, value } = event.target;

    let newContact = [...formValues?.contactDetails];
    newContact[index] = {
      ...newContact[index],
      [name]: value,
    };
    setFormValues((prev: any) => ({
      ...prev,
      contactDetails: newContact,
    }));
  };

  const handleAddPrice = () => {
    const newPrices = [...formValues.price, { price: 0, priceTitle: "", isPriceNotConfirmed: false }];
    setFormValues((prev: any) => ({
      ...prev,
      price: newPrices,
    }));
  };
  const handleAddContact = () => {
    const newContact = [
      ...formValues.contactDetails,
      { name: "", mobileNumber: "" },
    ];
    setFormValues((prev: any) => ({
      ...prev,
      contactDetails: newContact,
    }));
  };

  const handleAddUrl = () => {
    if (!galleryUrl.startsWith("https")) return;

    let existingFiles = [...(formValues.images || [])];
    let videoCount = existingFiles.filter((file: any) =>
      isVideoUrl(file)
    ).length;
    let imageCount = existingFiles.filter(
      (file: any) => !isVideoUrl(file)
    ).length;

    if (isVideoUrl(galleryUrl)) {
      if (videoCount >= 2) {
        alert("You can only add up to 2 videos.");
        return;
      }
    } else {
      if (imageCount >= 5) {
        alert("You can only add up to 5 images.");
        return;
      }
    }

    setFormValues((prev: any) => ({
      ...prev,
      images: [...prev.images, galleryUrl],
    }));
    setGalleryUrl("");
  };
  const handleRemovePrice = (index: number) => {
    const newPrices = formValues?.price.filter(
      (_: any, i: number) => i !== index
    );
    setFormValues((prev: any) => ({
      ...prev,
      price: newPrices,
    }));
  };
  const handleRemoveContact = (index: number) => {
    const newContact = formValues?.contactDetails.filter(
      (_: any, i: number) => i !== index
    );
    setFormValues((prev: any) => ({
      ...prev,
      contactDetails: newContact,
    }));
  };
  return (
    <Container>
      <Box style={{ display: "flex", alignItems: "center" }}>
        <Tooltip title="Back">
          <img
            src={backButton}
            alt="backButton"
            height={25}
            width={25}
            style={{ marginRight: "12px", cursor: "pointer" }}
            onClick={handleClose}
          />
        </Tooltip>
        <Typography
          variant="h4"
          gutterBottom
          style={{ color: "#00C5B9" }}
          marginTop={2}
        >
          {events ? "Update Event" : "Create Event"}
        </Typography>
      </Box>
      <form>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              name="title"
              margin="dense"
              label="Title"
              fullWidth
              required
              value={formValues?.title}
              onChange={handleInputChange}
              error={!!errors.title}
              helperText={errors.title}
            />
          </Grid>

          {/* <Grid item xs={12} sm={6}>
            <TextField
              name="description"
              margin="dense"
              label="Description"
              fullWidth
              value={formValues.description}
              onChange={handleInputChange}
              error={!!errors.description}
              helperText={errors.description}
            />
          </Grid> */}
          <Grid item xs={12}>
            <Typography>Description:</Typography>
            <RichTextEditor
              value={formValues?.description}
              onChange={(content: string) =>
                setFormValues({ ...formValues, description: content })
              }
              error={!!errors.description} // Pass error status
              helperText={errors.description} // Pass the error message
            // className={styles.descriptionWrapper}
            />
            {/* {formValues.touched.description &&
              formValues.touched.description && (
                <Typography color="error">
                  {formValues.touched.description &&
                    Boolean(formValues.errors.description)}
                </Typography>
              )} */}
          </Grid>
          <Grid item xs={12}>
            <FormControl component="fieldset" fullWidth margin="normal">
              <FormControlLabel
                control={
                  <Checkbox
                    name="isPromoted"
                    checked={formValues?.isPromoted}
                    onChange={handleInputChange}
                  />
                }
                label="Is Promoted"
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box marginTop={2}>
              <TextField
                name="startDate"
                margin="dense"
                label="Start Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                fullWidth
                value={formValues?.startDate}
                onChange={handleInputChange}
                error={!!errors.startDate}
                helperText={errors?.startDate}
                InputProps={{
                  inputProps: {
                    min: moment(new Date()).format("YYYY-MM-DD"),
                  },
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box marginTop={2}>
              <TextField
                name="endDate"
                margin="dense"
                label="End Date"
                type="date"
                InputLabelProps={{ shrink: true }}
                fullWidth
                value={formValues?.endDate}
                onChange={handleInputChange}
                error={!!errors.endDate}
                helperText={errors.endDate}
                InputProps={{
                  inputProps: {
                    min: moment(formValues.startDate).format("YYYY-MM-DD"),
                  },
                }}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box marginTop={2}>
              <TextField
                name="startTime"
                margin="dense"
                label="Start Time"
                type="time"
                fullWidth
                value={formValues?.startTime}
                onChange={handleInputChange}
                InputLabelProps={{
                  shrink: true,
                }}
                error={!!errors.startTime}
                helperText={errors.startTime}
              />
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box marginTop={2}>
              <TextField
                name="endTime"
                margin="dense"
                label="End Time"
                type="time"
                fullWidth
                value={formValues?.endTime}
                onChange={handleInputChange}
                InputLabelProps={{
                  shrink: true,
                }}
                error={!!errors.endTime}
                helperText={errors.endTime}
              />
            </Box>
          </Grid>

          <Grid container item xs={12} spacing={2}>
            {formValues?.price?.map((priceField: any, index: number) => (
              <Grid item xs={12} sm={6} key={index}>
                <TextField
                  name="price"
                  label="Price"
                  margin="dense"
                  type="number"
                  fullWidth
                  value={priceField?.price}
                  onChange={(e) => handlePriceChange(index, e)}
                  error={!!errors[`price${index}`]}
                  helperText={errors[`price${index}`]}
                  inputProps={{ min: 0 }}
                />
                <TextField
                  name="priceTitle"
                  label="Price Title"
                  margin="dense"
                  fullWidth
                  value={priceField?.priceTitle || priceField?.pricetitle || ""}
                  onChange={(e) => handlePriceChange(index, e)}
                  error={!!errors[`priceTitle${index}`]}
                  helperText={errors[`priceTitle${index}`]}
                />
                <FormControlLabel
                  control={
                    <Checkbox
                      name="isPriceNotConfirmed"
                      checked={priceField?.isPriceNotConfirmed || false}
                      onChange={(e) => handlePriceChange(index, e)}
                      color="primary"
                    />
                  }
                  label="Checked this if Price is not confirmed"
                />
                <Tooltip title="Add">
                  <IconButton
                    color="primary"
                    onClick={handleAddPrice}
                    disabled={formValues?.price?.length > 11}
                  >
                    <AddCircleOutline />
                  </IconButton>
                </Tooltip>
                {formValues?.price?.length > 1 && (
                  <Tooltip title="Remove">
                    <IconButton
                      color="secondary"
                      onClick={() => handleRemovePrice(index)}
                    >
                      <RemoveCircleOutline />
                    </IconButton>
                  </Tooltip>
                )}
              </Grid>
            ))}
          </Grid>

          <Grid item xs={12} sm={6}>
            <Box my={2}>
              <Typography variant="h6" gutterBottom>
                Language
              </Typography>
              <FormControl fullWidth sx={{ zIndex: "999999" }}>
                <Select
                  options={languageOptions}
                  value={languageOptions.find(
                    (option) => option.value === formValues?.language
                  )}
                  onChange={(data) =>
                    setFormValues((prev: any) => ({
                      ...prev,
                      language: data?.value,
                    }))
                  }
                  placeholder="Filter by Category"
                />
                {!!errors.type && (
                  <Typography
                    variant="subtitle2"
                    mt={1}
                    mx={2}
                    color={"#D32f2f"}
                  >
                    {errors.language}
                  </Typography>
                )}
              </FormControl>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box my={2}>
              <Typography variant="h6" gutterBottom>
                Type
              </Typography>
              <FormControl fullWidth sx={{ zIndex: "9999" }}>
                <Select
                  options={eventCategories}
                  value={eventCategories.find(
                    (option: any) => option?.value === formValues?.type
                  )}
                  onChange={(data) =>
                    setFormValues((prev: any) => ({
                      ...prev,
                      type: data?.value,
                    }))
                  }
                  placeholder="Filter by Category"
                />
                {!!errors.type && (
                  <Typography
                    variant="subtitle2"
                    mt={1}
                    mx={2}
                    color={"#D32f2f"}
                  >
                    {errors.type}
                  </Typography>
                )}
              </FormControl>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12}>
            {
              <Box my={2}>
                <AddressInput
                  pincode={formValues?.pincode}
                  address={formValues?.address as any}
                  setAddress={setFormValues as any}
                  setValues={setFormValues}
                  errors={errors}
                />

                {errors.pinCode && (
                  <Typography variant="caption" color="error" mx={1.5}>
                    {errors.pinCode}
                  </Typography>
                )}
              </Box>
            }
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="venue"
              margin="dense"
              label="Venue"
              fullWidth
              value={formValues?.venue}
              onChange={handleInputChange}
              error={!!errors.venue}
              helperText={errors.venue}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="artist"
              margin="dense"
              label="Artist"
              fullWidth
              value={formValues?.artist}
              onChange={handleInputChange}
              error={!!errors.artist}
              helperText={errors.artist}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name="eventBy"
              margin="dense"
              label="Event By"
              fullWidth
              value={formValues?.eventBy}
              onChange={handleInputChange}
              error={!!errors.eventBy}
              helperText={errors.eventBy}
            />
          </Grid>
          <Grid item xs={12} sm={12}>
            <TextField
              name="bookingPartner"
              margin="dense"
              label="Booking Partner"
              fullWidth
              value={formValues?.bookingPartner}
              onChange={handleInputChange}
              error={!!errors.bookingPartner}
              helperText={errors.bookingPartner}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Meta Title"
              name="metaTitle"
              value={formValues?.metaTitle}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              error={!!errors.metaTitle}
              helperText={errors.metaTitle}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              type="text-area"
              label="Meta Description"
              name="metaDescription"
              value={formValues?.metaDescription}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              error={!!errors.metaDescription}
              helperText={errors.metaDescription}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              type="text-area"
              label="Focus Keywords"
              name="focus"
              value={formValues?.focus}
              onChange={handleInputChange}
              fullWidth
              variant="outlined"
              error={!!errors.focus}
              helperText={errors.focus}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              name="imageAltText"
              label="Image Alt Text"
              margin="dense"
              fullWidth
              multiline
              rows={4}
              value={formValues.imageAltText}
              onChange={handleInputChange}
              error={!!errors.imageAltText}
              helperText={errors.imageAltText}
            />
          </Grid>
          {/* Desktop Image Upload */}
          <Grid item xs={12} sm={6}>
            <Typography variant="h6" gutterBottom>
              Desktop Image
            </Typography>
            {formValues?.desktopImage ? (
              <Box
                position="relative"
                width="100%"
                height="auto"
                display={"flex"}
                justifyContent={"center"}
                alignItems={"center"}
              >
                <Box>
                  <img
                    src={
                      typeof formValues.desktopImage === "string"
                        ? formValues.desktopImage
                        : URL.createObjectURL(formValues.desktopImage)
                    }
                    alt="Desktop Upload"
                    style={{
                      width: "100%",
                      height: "auto",
                      maxHeight: "500px",
                      objectFit: "cover",
                    }}
                  />
                </Box>
                <CustomButton
                  variant="outlined"
                  color="warning"
                  style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    zIndex: 1,
                    borderRadius: "50%",
                    width: "32px",
                    height: "32px",
                    minWidth: "0",
                    backgroundColor: "white",
                  }}
                  onClick={() => {
                    setFormValues((prev: any) => ({
                      ...prev,
                      desktopImage: "",
                    }));
                  }}
                  aria-label="Remove image"
                >
                  <Tooltip title="Remove">
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",

                        borderRadius: "50%",
                      }}
                    >
                      &times;
                    </Box>
                  </Tooltip>
                </CustomButton>
              </Box>
            ) : (
              <label>
                <input
                  ref={desktopImageRef}
                  type="file"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e, "desktopImage")}
                />
                <CustomButton
                  variant="outlined"
                  size="small"
                  onClick={() => desktopImageRef.current?.click()}
                >
                  Upload Desktop Image
                </CustomButton>
                <TextField
                  label="Or Enter Image URL"
                  value={desktopUrl ?? (formValues.desktopImage || "")}
                  onBlurCapture={(e) => {
                    if (desktopUrl?.startsWith("https")) {
                      setFormValues((prev: any) => ({
                        ...prev,
                        desktopImage: desktopUrl,
                      }));
                    } else {
                      setDesktopUrl("");
                      setFormValues((prev: any) => ({
                        ...prev,
                        desktopImage: "",
                      }));
                    }
                  }}
                  onChange={(e) => setDesktopUrl(e.target.value)}
                  fullWidth
                  margin="normal"
                />
              </label>
            )}
          </Grid>

          {/* Images/Videos Section */}
          <Box marginTop={2} mx={2}>
            <Typography variant="h6" gutterBottom>
              Gallery Images / Videos
            </Typography>
            {formValues?.images?.length > 0 && (
              <Grid container spacing={2}>
                {formValues?.images?.map(
                  (fileUrl: string | File, index: number) => (
                    <Grid
                      item
                      xs={6}
                      sm={4}
                      md={3}
                      // key={index}
                      key={fileUrl instanceof File ? fileUrl.name : fileUrl}
                    >
                      <Box
                        position="relative"
                        width="100%"
                        height="auto"
                        marginRight={20}
                      >
                        <Box>
                          {isVideoUrl(fileUrl) ? (
                            <DisplayVideo
                              item={
                                typeof fileUrl === "string"
                                  ? fileUrl
                                  : URL.createObjectURL(fileUrl)
                              }
                            />
                          ) : (
                            <img
                              src={
                                typeof fileUrl === "string"
                                  ? fileUrl
                                  : URL.createObjectURL(fileUrl)
                              }
                              alt={`event-${index}`}
                              style={{
                                width: "100%",
                                minWidth: "fit",
                                height: "200px",
                                objectFit: "cover",
                                borderRadius: "8px",
                              }}
                            />
                          )}
                        </Box>
                        <CustomButton
                          variant="outlined"
                          color="warning"
                          style={{
                            position: "absolute",
                            top: "8px",
                            right: "8px",
                            zIndex: 1,
                            borderRadius: "50%",
                            width: "32px",
                            height: "32px",
                            minWidth: "0",
                            backgroundColor: "white",
                          }}
                          onClick={() => {
                            setFormValues((prev: any) => ({
                              ...prev,
                              images: prev.images.filter(
                                (img: any) => img !== fileUrl
                              ), // Filter by file reference
                            }));
                          }}
                          aria-label="Remove image"
                        >
                          <Tooltip title="Remove">
                            <Box
                              sx={{
                                width: "100%",
                                height: "100%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                borderRadius: "50%",
                              }}
                            >
                              &times;
                            </Box>
                          </Tooltip>
                        </CustomButton>
                      </Box>
                    </Grid>
                  )
                )}
              </Grid>
            )}

            <Box sx={{ marginY: "10px", display: "flex", gap: 2 }}>
              {/* Toggle between Upload and URL */}
              <CustomButton
                variant={useUrl ? "outlined" : "contained"}
                onClick={() => setUseUrl(false)}
              >
                Upload File
              </CustomButton>
              <CustomButton
                variant={useUrl ? "contained" : "outlined"}
                onClick={() => setUseUrl(true)}
              >
                Add via URL
              </CustomButton>
            </Box>

            {!useUrl ? (
              <Box
                sx={{
                  borderRadius: 2,
                  marginY: "10px",
                  border: "2px dashed #00C5B9",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  overflow: "hidden",
                  height: "200px",
                }}
                onClick={() => fileInputRef.current?.click()}
              >
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*,  video/mp4, video/webm, video/ogg, video/quicktime, video/x-matroska"
                  multiple
                  style={{ display: "none" }}
                  onChange={handleMultipleFileChange}
                />
                <CustomButton
                  variant="outlined"
                  style={{ border: "none" }}
                  size="small"
                >
                  Upload Images/Videos
                </CustomButton>
              </Box>
            ) : (
              <Box sx={{ marginY: "10px" }}>
                <TextField
                  label="Enter URL"
                  value={galleryUrl}
                  onChange={(e) => setGalleryUrl(e.target.value)}
                  fullWidth
                  margin="normal"
                />
                <CustomButton
                  variant="contained"
                  onClick={handleAddUrl}
                  disabled={!galleryUrl.startsWith("https")}
                >
                  Add URL
                </CustomButton>
              </Box>
            )}
          </Box>
        </Grid>
        <Box marginTop={2}>
          <Typography variant="h6" gutterBottom>
            Contact Details
          </Typography>
          <Grid container spacing={2}>
            {formValues?.contactDetails?.map(
              (contactField: any, index: number) => (
                <Grid
                  container
                  item
                  xs={12}
                  key={index}
                  spacing={2}
                  alignItems="center"
                >
                  <Grid item xs={5}>
                    <TextField
                      name="name"
                      margin="dense"
                      label="Name"
                      fullWidth
                      value={contactField.name}
                      onChange={(e) => handleContactChange(index, e)}
                      error={!!errors.name}
                      helperText={errors.name}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <TextField
                      name="mobileNumber"
                      margin="dense"
                      label="Mobile Number"
                      fullWidth
                      value={contactField.mobileNumber}
                      onChange={(e) => handleContactChange(index, e)}
                      error={!!errors.mobileNumber}
                      helperText={errors.mobileNumber}
                    />
                  </Grid>
                  <Grid item xs={1}>
                    <Tooltip title="Add">
                      <IconButton
                        color="primary"
                        onClick={handleAddContact}
                        disabled={formValues?.contactDetails?.length > 4}
                      >
                        <AddCircleOutline />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item xs={1}>
                    {formValues?.contactDetails?.length > 1 && (
                      <Tooltip title="Remove">
                        <IconButton
                          color="secondary"
                          onClick={() => handleRemoveContact(index)}
                        >
                          <RemoveCircleOutline />
                        </IconButton>
                      </Tooltip>
                    )}
                  </Grid>
                </Grid>
              )
            )}
          </Grid>
        </Box>
        <Box marginTop={2}>
          {loading ? (
            <CircularProgress
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            />
          ) : (
            <CustomButton onClick={handleSubmit}>
              {events ? "Update" : "Create"}
            </CustomButton>
          )}
        </Box>
      </form>
    </Container>
  );
};

export default EventsPage;
